@if (loading && !config) {
<div class="cj-card cj-card--skeleton">
  <div class="cj-sk__title sk-bone"></div>
  <div class="cj-sk__canvas sk-bone"
       [class.cj-sk__canvas--tall]="size === 'tall'"
       [class.cj-sk__canvas--md]="size === 'md'"
       [class.cj-sk__canvas--sm]="size === 'sm'"></div>
</div>
} @else if (config) {
<div class="cj-card" [class.cj-card--refreshing]="loading">

  <!-- Header -->
  <div class="cj-card__header">
    <h4 class="cj-card__title">{{ config.title }}</h4>
  </div>

  <!-- Canvas -->
  <div class="cj-card__canvas-wrap"
       [class.cj-card__canvas-wrap--tall]="config.size === 'tall' || (!config.size && config.chartType === 'cj_bar_h')"
       [class.cj-card__canvas-wrap--md]="config.size === 'md' || (!config.size && (config.chartType === 'cj_radar' || config.chartType === 'cj_polar'))"
       [class.cj-card__canvas-wrap--sm]="config.size === 'sm'">
    <canvas #canvas></canvas>
  </div>

</div>
}
